import http from "@/utils/request";

const danding = {
  pageQueryReturnQualityInspections: data =>
    http.sendRequest({
      METHOD_NAME: "returnQualityInspection.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  queryReturnQualityInspection: data =>
    http.sendRequest({
      METHOD_NAME: "returnQualityInspection.query",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  submitReturnQualityInspection: data =>
    http.sendRequest({
      METHOD_NAME: "returnQualityInspection.submit",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),

  // 退货订单
  queryGoodsReturnList: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  importGoodsReturnExcel: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.importCDGoodsReturnOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  previewGoodsReturnData: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.previewCDGoodsReturnOrderImport",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  cancelGoodsReturn: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.cancelCDGoodsReturnOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  getGoodsReturnDetail: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.getCDGoodsReturnOrderDetail",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  finishGoodsReturn: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.finishCDGoodsReturnOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  submitGoodsReturnOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.submitCDGoodsReturnOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  exportGoodsReturnOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.submitCustomsGoodsReturnOrderExcelTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  previewMakePurchaseGoods: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.previewMakePurchaseGoods",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  makePurchaseOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.makePurchaseOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),

  // 核放单
  fetchNuclearReleaseList: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  addNuclearReleaseList: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.batchCreateCustomsChecklistOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  closeNuclearRelease: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.cancelCustomsChecklistOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  enterNuclearReleaseOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.enterRealChecklistOrderNo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  exportNuclearReleaseList: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.submitCustomsChecklistOrderExcelTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  fetchNuclearReleaseDetail: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.getCustomsChecklistOrderDetail",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  updateNuclearReleaseOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.updateCustomsChecklistOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  fetchCarrierAllList: data =>
    http.sendRequest({
      METHOD_NAME: "carriers.carrierAllList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  exportNuclearReleaseBaseInfo: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.downloadChecklistOrderBaseInfoTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  previewChecklistOrderMailNoImport: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.previewChecklistOrderMailNoImport",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  importChecklistOrderMailNo: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.importChecklistOrderMailNo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  declareChecklistOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.declareChecklistOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  queryVehicleList: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.queryVehicleList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  asynSubmitMailNosImport: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.asynSubmitMailNosImport",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),

  // 核注清单管理
  addEndorsementOrderByChecklistOrderNo: data =>
    http.sendRequest({
      METHOD_NAME: "customsEndorsement.addEndorsementOrderByChecklistOrderNo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  finishEndorsementOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsEndorsement.finishEndorsementOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  getEndorsementDetail: data =>
    http.sendRequest({
      METHOD_NAME: "customsEndorsement.getEndorsementDetail",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  nuclearPageQuery: data =>
    http.sendRequest({
      METHOD_NAME: "customsEndorsement.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  editEndorsementOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsEndorsement.editEndorsementOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  batchDownloadEndorsementOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsEndorsement.batchDownloadEndorsementOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  declareEndorsementOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsEndorsement.declareEndorsementOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  orderSplitByChecklistOrderExist: data =>
    http.sendRequest({
      METHOD_NAME: "customsChecklist.orderSplitByChecklistOrderExist",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),

  // 撤单管理
  cancelLationsPageQuery: data =>
    http.sendRequest({
      METHOD_NAME: "customsRevokeOrder.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  batchDeclareRevokeOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsRevokeOrder.batchDeclareRevokeOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  batchDeleteRevokeOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsRevokeOrder.batchDeleteRevokeOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  importRevokeOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsRevokeOrder.importRevokeOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  previewRevokeOrderImport: data =>
    http.sendRequest({
      METHOD_NAME: "customsRevokeOrder.previewRevokeOrderImport",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  exportRevokeOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsRevokeOrder.exportRevokeOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  makeReturnDeclareOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.makeReturnDeclareOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  returnDeclareOrderPageQuery: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.returnDeclareOrderPageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  loadReturnDeclareOrder: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.loadReturnDeclareOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    }),
  querySkuByMerchantOrderNoList: data =>
    http.sendRequest({
      METHOD_NAME: "customsGoodsReturn.querySkuByMerchantOrderNoList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    })
};

export default danding;
